import { CostTabData, GroupedByCostSource } from "../types";
import {
  CostTableSource,
  CostTimeseriesData,
  CostTimeseriesKey,
} from "src/store/api/generatedApi";
import { typeSafeObjectFromEntries } from "src/utils/typeSafeObjectFromEntries";

export const buildSeriesCollection = (
  data: Record<string, CostTimeseriesData>
): CostTabData => {
  return typeSafeObjectFromEntries(
    Object.entries(data).map(([key, value]) => [
      key as CostTableSource,
      buildSeriesDataGroupedBySource(value),
    ])
  );
};

const extractDenominators = (series: CostTimeseriesKey[]) => {
  return Array.from(new Set(series.map((item) => item.mass_denominator)));
};

const buildSeriesDataGroupedBySource = ({
  series,
  sources,
  table_source,
  range_mode,
}: CostTimeseriesData): GroupedByCostSource => {
  const availableMassDenominators = extractDenominators(series);
  return {
    seriesCollection: sources.flatMap((source) =>
      availableMassDenominators.map((massDenominator) => ({
        source,
        massDenominator,
        items: series
          .filter(
            (point) =>
              point.source === source &&
              point.mass_denominator === massDenominator
          )
          .map((point) => ({
            date: point.date,
            cost: point.cost,
            source: point.source,
            mass_denominator: point.mass_denominator,
            time_aggregation: point.time_aggregation,
          })),
      }))
    ),
    availableSources: sources,
    availableMassDenominators: availableMassDenominators,
    tableSource: table_source,
    rangeMode: range_mode,
  };
};
